import { CarrierCargoListPage } from "@/pages/carrier-cargo-list";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth_requeired/carrier/cargos/")({
  component: () => {
    const { tab } = useSearch({ strict: false });
    return <CarrierCargoListPage tab={tab} />;
  },
  validateSearch: z.object({
    tab: z.union([z.literal("not_proposed"), z.literal("proposed")]).optional(),
  }),
});
